import AlgarTelecomIco1 from "../assets/providers/algar-telecom.png";
import CorreioCelularIco from "../assets/providers/correio-celular.webp";
import TimCelularIco from "../assets/providers/tim.webp";
import VivoCelularIco from "../assets/providers/vivo-celular.webp";
import ClaroCelularIco from "../assets/providers/claro-celular.png";
import SerComTelIcon from "../assets/providers/sercomtel.png";
import SurfTelecomIcon from "../assets/providers/surf-telecom.webp";

const getUrlImage = (provider, width = null) => {
  if (provider == "CLARO") {
    return (
      <img
        src={ClaroCelularIco}
        alt="claro-icon"
        style={{
          width: "50px",
        }}
      />
    );
  } else if (provider == "VIVO") {
    return (
      <img
        src={VivoCelularIco}
        alt="vivo-icon"
        style={{ width: width ? width : "80px", marginTop: 8 }}
      />
    );
  } else if (provider == "TIM") {
    return (
      <img
        src={TimCelularIco}
        alt="tim-icon"
        style={{ width: width ? width : "80px" }}
      />
    );
  } else if (provider == "Correio Celular") {
    return (
      <img
        src={CorreioCelularIco}
        alt="correio-celular-icon"
        style={{ width: width ? width : "80px" }}
      />
    );
  } else if (provider == "Algar Celular") {
    return (
      <img
        src={AlgarTelecomIco1}
        alt="algar-telecom-icon"
        style={{ width: width ? width : "70px" }}
      />
    );
  } else if (provider == "SERCOMTEL") {
    return (
      <img
        src={SerComTelIcon}
        alt="sercom-telecom-icon"
        style={{ width: width ? width : "90px" }}
      />
    );
  } else if (provider == "Surf Telecom") {
    return (
      <img
        src={SurfTelecomIcon}
        alt="surf-telecom-icon"
        style={{ width: width ? width : "80px" }}
      />
    );
  }
};
function formatCNAE(cnae) {
    if (!cnae) return "—"; // ou "N/A", ou ""
  const onlyDigits = String(cnae).replace(/\D/g, "").padStart(7, "0"); // garante 7 dígitos
  const part1 = onlyDigits.slice(0, 4);
  const part2 = onlyDigits.slice(4, 5);
  const part3 = onlyDigits.slice(5, 7);
  return `${part1}-${part2}/${part3}`;
}

function formatarCodTribNac(codigo) {
    if (!codigo) return "—"; // ou "N/A", ou ""

  // Garante que seja string e tenha 6 dígitos com zeros à esquerda
  const str = String(codigo).padStart(6, "0");

  // Retorna no formato XX.XX.XX
  return `${str.substring(0, 2)}.${str.substring(2, 4)}.${str.substring(4, 6)}`;
}

export { getUrlImage, formatCNAE, formatarCodTribNac };
